/**
 * ? @description : Create Group Component
 */

// Dependencies
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Form, Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";

// Assets
import warning from "../../../../../../assets/warning-symbol.svg";

// Component
import AddTeacherParticipantModal from "./add_teacher_modal/AddTeacherParticipantModal";

// Axios Component
import Axios from "../../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../../redux/features/appSlice";

// CSS Component
import "../../../../../../css/CreateGroup.css";
import { FormControlLabel, Stack, Switch, TextField } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import { Chip } from "@mui/material";


function CreateGroup({ props, mailTemplate }) {
  // * Redux Variables
  const dispatch = useDispatch();
  // * Navigation
  const navigate = useNavigate();

  const user_id = sessionStorage.getItem("user_id");

  // * State Variables
  // const [addParticipants, setAddParticipants] = useState(null);
  const [participantsModalShow, setParticipantsModalShow] = useState(false);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  // console.log(selectedTeachers);
  const [groupData, setGroupData] = useState({
    groupname: "",
    groupdescription: null,
    training_start_date: "",
    batch_created_by: "",
  });
  const [validateGroupData, setValidateGroupData] = useState({
    isInvalidGroupName: false,
    isInvalidGroupDescription: false,
    isInvalidTrainingStartDate: false
  });
  // console.log(groupData.training_start_date)
  const [loading, setLoading] = useState(false)

  const [date, setDate] = useState(
    groupData.training_start_date !== "" ? dayjs(groupData.training_start_date) : null
  )

  const [addTeachers, setAddTeachers] = useState(false);
  const [editable, setEditable] = useState(false);
  const [content, setContent] = useState(mailTemplate)

  // console.log(addTeachers);
  // ! Form Field Validation
  const groupDataValidation = (e) => {
    e.preventDefault();

    let canSubmitData = true;
    let invalidGroupName = false;
    let invalidGroupDescription = false;
    let invalidTrainingStartDate = false;

    if (groupData.groupname.length === 0) {
      invalidGroupName = true;
      canSubmitData = false;
    }

    // if (groupData.groupdescription.length === 0) {
    //   invalidGroupDescription = true;
    //   canSubmitData = false;
    // }

    if (groupData.training_start_date.length === 0) {
      invalidTrainingStartDate = true;
      canSubmitData = false;
    }

    setValidateGroupData({
      ...validateGroupData,
      isInvalidGroupName: invalidGroupName,
      isInvalidGroupDescription: invalidGroupDescription,
      isInvalidTrainingStartDate: invalidTrainingStartDate
    });

    return canSubmitData;
  };

  // TODO : API Call : Get Method : Get Ungrouped Teachers Data
  // async function addTeachersData() {
  //   try {
  //     const options = {
  //       method: "get",
  //       url: `/batchview/ungroupedteachers`,
  //       auth: true,
  //       data: null,
  //     };

  //     const response = await Axios(
  //       options.method,
  //       options.url,
  //       options.auth,
  //       options.data
  //     );

  //     if (response.status === 200) {
  //       ;
  //     }
  //   } catch (error) {
  //     dispatch(
  //       showSnackbar({
  //         message:
  //           "Error occurred! Unable to fetch data. Please try again later.",
  //         severity: "error",
  //       })
  //     );
  //   }
  // }

  // ? API Call : Post Method : Create Batch
  async function postBatchData() {
    if (selectedTeachers.length > 0) {
      setLoading(true);
      setTimeout(async () => {
        try {
          setLoading(true);
          const formBatchData = {
            batch_name: groupData.groupname,
            batch_desc: groupData.groupdescription,
            training_date_for_batch: dayjs(groupData.training_start_date).format("YYYY-MM-DD"),
            batch_created_by: user_id,
          };

          const options = {
            method: "post",
            url: "/batches",
            auth: true,
            data: formBatchData,
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data
          );
          
          if (response.status === 201) {
            postBatchMemberData(
              response.data[0].batch_id,
              response.data[0].batch_name
            );
            // setLoading(false);
          } else if (response.status ===  202){
            setLoading(false);
            dispatch(
              showSnackbar({
                message: response.data,
                severity: "error",
              })
            );
          }
        } catch (error) {
          setLoading(false);
          dispatch(
            showSnackbar({
              message: "Unable to create batch. Please try again later.",
              severity: "error",
            })
          );
        }
      }, 1000)

    } else {
      setLoading(false);
      dispatch(
        showSnackbar({
          message:
            "Please select atleast one volunteer profile to create batch.",
          severity: "error",
        })
      );
    }
  }

  // ! Form Data in Array Format
  const formArrayPostValue = (id, name) => {
    const formGroupDataLocal = [];

    selectedTeachers.map((teacher) => {
      return formGroupDataLocal.push({
        batch_member_id: teacher.teacher_id,
        batch_member_name: teacher.teacher_name,
        batch_member_type: "teacher",
        batch_ids: id,
        batch_name: name,
        batch_member_created_by: user_id,
      });
    });

    return formGroupDataLocal;
  };

  // ? API Call : Post Method : Add Multiple Teachers to Batch
  async function postBatchMemberData(id, name) {
    try {
      setLoading(true);
      let formGroupData = [];

      let batch_id = id;
      let batch_name = name;

      formGroupData = formArrayPostValue(batch_id, batch_name);
      // console.log(formGroupData);

      const combinedData = {
        batch_id:batch_id,
        training_date_for_batch: dayjs(groupData.training_start_date).format("YYYY-MM-DD"),
        batch_members: formGroupData,
        my_message: content
      }
      // console.log(combinedData);
      const options = {
        method: "POST",
        // url: "/batchmembers",
        url: "batches/add/batch/member",
        auth: true,
        data: combinedData,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 201 ||response.status === 200 ) {
        // console.log(response);
        setGroupData({ ...groupData, groupname: "", groupdescription: "" });
        setLoading(false);
        dispatch(
          showSnackbar({
            message: "Batch created successfully !",
            severity: "success",
          })
        );
        props.onHide();
        props.onCloseCallBack();
        // navigate("/lte-session");
        // window.location.reload();
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message:
            "Error occurred! Unable to post data. Please try again later.",
          severity: "error",
        })
      );
    }
  }

  function AddMoreTeachers({ open, onClose }) {

    return (
      <Modal
        show={open}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2000, position: 'fixed' }}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5 style={{ color: "#ff3333" }}>
              Warning!&nbsp;
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p> If you want select more teachers previous selected lists will disappear</p>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              type="button"
              variant="light"
              onClick={onClose}
            > CANCEL</Button>
          </div>

          <div>
            <Button
              type="button"
              variant="primary"
              // onSubmit={ onClose }
              onClick={() => {
                onClose()
                setParticipantsModalShow(true)
              }}
            >
              CREATE
            </Button>
          </div>
        </Modal.Footer>

      </Modal>

    )
  }

  const style = {
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "10px 16px",
    // height: "120px"
  }

  const styleBox = {
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "8px 12px",
    height: "180px"
  }

  return (
    <div className="creategroup">
      <Stack spacing={2} justifyContent="center" alignItems="center">
        {/* Form */}
        {/* <Form> */}
        {/* <Form.Group>
            <Form.Label>Group Name</Form.Label>
            <Form.Control
              type="text"
              name="groupname"
              placeholder="Enter the group name"
              value={groupData.groupname}
              onChange={(event) => {
                setGroupData({ ...groupData, groupname: event.target.value });
                setValidateGroupData({
                  ...validateGroupData,
                  isInvalidGroupName: false,
                });
              }}
              isInvalid={validateGroupData.isInvalidGroupName}
            />
            <Form.Control.Feedback type="invalid">
            Group name is mandatory.
            </Form.Control.Feedback>
          </Form.Group> */}
        <Stack spacing={1} direction="row" alignItems="center" justifyContent="center" sx={{ width: "100%" }}>
          <TextField
            sx={{ width: "70%" }}
            size="small"
            label="Batch name"
            value={groupData.groupname}
            onChange={(event) => {
              setGroupData({ ...groupData, groupname: event.target.value });
              setValidateGroupData({
                ...validateGroupData,
                isInvalidGroupName: false,
              });
            }}
            error={validateGroupData.isInvalidGroupName}
            helperText={validateGroupData.isInvalidGroupName && "Batch name is mandatory."}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              sx={{ width: "30%" }}
              label="Training date"
              disablePast
              value={date}
              onChange={(e) => {
                const newDate = e === null ? "" : e;
                setGroupData(prev => ({ ...prev, training_start_date: newDate }));
                setValidateGroupData(prev => ({ ...prev, isInvalidTrainingStartDate: false }));
              }}
              slots={{
                textField: (params) => <TextField
                  size="small"
                  error={validateGroupData.isInvalidTrainingStartDate}
                  helperText={validateGroupData.isInvalidTrainingStartDate && "Batch created date is mandatory"}
                  {...params}
                />
              }}
            />
          </LocalizationProvider>
        </Stack>


        {/* <Form.Group>
            <Form.Label>Group Description</Form.Label>
            <Form.Control
              type="text"
              name="groupdescription"
              placeholder="Enter the group description"
              value={groupData.groupdescription}
              onChange={(event) => {
                setGroupData({
                  ...groupData,
                  groupdescription: event.target.value,
                });
                setValidateGroupData({
                  ...validateGroupData,
                  isInvalidGroupDescription: false,
                });
              }}
              isInvalid={validateGroupData.isInvalidGroupDescription}
            />
            <Form.Control.Feedback type="invalid">
            Group description is mandatory.
            </Form.Control.Feedback>
          </Form.Group> */}

        {/* <TextField
          sx={{ width: "70%" }}
          size="small"
          label="Batch description"
          value={groupData.groupdescription}
          onChange={(event) => {
            setGroupData({
              ...groupData,
              groupdescription: event.target.value,
            });
            setValidateGroupData({
              ...validateGroupData,
              isInvalidGroupDescription: false,
            });
          }}
          error={validateGroupData.isInvalidGroupDescription}
          helperText={validateGroupData.isInvalidGroupDescription && "Batch description is mandatory."}
        /> */}

        {/* <p style={{ display: "flex", alignItems: "center" }}>
            Profile Include
            <span className="add-teacher-profile">*</span>
            <img src={warning} alt="warning" />
            <span className="warning-message">
              You must include atleast one teacher when you create a Batch
            </span>
          </p> */}

        {/* Information & Add Teacher Button */}
        <Stack spacing={1} direction="column" alignItems="center" justifyContent="space-between" sx={style}>
          <p className="teacherCount">Selected Teachers List&nbsp;:&nbsp;({selectedTeachers.length})</p>
          <Box className='teacher-chips'
            // sx={selectedTeachers === 0 ? { display: "none" } : { display: "flex" }}
            sx={{ display: "flex", maxHeight:"100px", overflowY: "auto" }}
          >

            {selectedTeachers.map((value, index) => {
              return (
                <Chip
                  key={index}
                  label={value.teacher_name}
                  size="small"
                  color="primary"
                  onDelete={() => {
                    setSelectedTeachers((teacherList) => teacherList.filter((teachers) => teachers.teacher_name !== value.teacher_name))
                  }}
                />
              )
            })}
          </Box>
          <div className="addTeacherButton">
            <Button
              type="button"
              variant="primary"
              className="addTeacher"
              sx={{ width: "70%" }}

              onClick={() => { selectedTeachers.length > 0 ? setAddTeachers(true) : setParticipantsModalShow(true); }}
            >
              Add Teacher
            </Button>
          </div>


          {/* <div>
              Selected Teachers List&nbsp;:
                <ul>
                  {selectedTeachers.map((value, index) => {
                    return <li key={index}>{value.teacher_name}</li>;
                  })}
                </ul>
            </div> */}

        </Stack>

        <Stack spacing={2} direction="column" alignItems="center" sx={styleBox}>
          <div className="messageBox">
            <p className="message">Message</p>
            <FormControlLabel
              value={editable}
              onChange={() => setEditable(!editable)}
              control={<Switch color="primary" />}
              label="Edit Message"
              labelPlacement="start"
            />
          </div>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            value={content}
            color='primary'
            size="small"
            disabled={!editable}
            onChange={(e) => {
              setContent(e.target.value);
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  border: 'none',
                },
              },
              maxHeight: "200px",
              overflowY: "auto",
              padding: "0px"
            }}
          />



        </Stack>

        {/* Buttons */}
        <div className="cg-btn" style={{ margin: "0px" }}>
          <Button type="button" variant="light" onClick={props.onHide}>
            CANCEL
          </Button>

          <LoadingButton
            type="submit"
            variant="primary"
            className="batchSave"
            loading={loading}
            sx={{ color: 'white' }}
            onClick={(e) => {
              let isValid = groupDataValidation(e);
              setDate(groupData.training_start_date !== "" ? dayjs(groupData.training_start_date) : "")
              if (isValid) {
                postBatchData();
              } else {
                dispatch(
                  showSnackbar({
                    message: "Please fill all the fields !",
                    severity: "error",
                  })
                );
              }
            }}
          >
            CREATE
          </LoadingButton>
        </div>
        {/* </Form> */}
      </Stack>
      < AddMoreTeachers
        open={addTeachers}
        onClose={() => setAddTeachers(false)}
      />
      {/* Modal for Adding Teachers */}
      <AddTeacherParticipantModal
        show={participantsModalShow}
        onHide={() => setParticipantsModalShow(false)}
        selectedteacher={setSelectedTeachers}
      />
    </div>
  );
}

export default CreateGroup;
